import { Button, MultipleSelector } from "@dune/ui";
import { useFormContext } from "react-hook-form";
import { useShouldDisplayHTAmount } from "../../../../hooks/useParticipantToSubmissionForm";
import { ControlledPriceInput } from "../../../../components/inputs/ControlledPriceInput";
import type { MaterialToReceptionFormData } from "../../../../pages/constructionSites/reception/participants/useParticipantToReceptionForm";
import { useMaterialReceptionDocumentRows } from "../../../../pages/constructionSites/reception/participants/useParticipantToReceptionForm";
import { ReceptionDocumentsTable } from "./ReceptionDocumentsTable";

interface MaterialToReceptionFormProps {
	constructionSiteId: number;
	onSubmit: () => void;
	onCancel: () => void;
	isSubmitting?: boolean;
}

export const MaterialToReceptionForm = ({
	constructionSiteId,
	onSubmit,
	onCancel,
	isSubmitting = false,
}: MaterialToReceptionFormProps) => {
	const {
		control,
		watch,
		setValue,
		formState: { errors },
	} = useFormContext<MaterialToReceptionFormData>();

	const { shouldDisplayHT } = useShouldDisplayHTAmount(constructionSiteId);

	const documentRows = useMaterialReceptionDocumentRows();

	return (
		<div className="space-y-6">
			<ReceptionDocumentsTable
				constructionSiteId={constructionSiteId}
				documentRows={documentRows}
			/>

			<MultipleSelector
				label="Types de matériaux"
				options={[]}
				placeholder="Ajouter"
				creatable={true}
				value={(watch("materialTypes") || []).map((material) => ({
					value: material,
					label: material,
				}))}
				onChange={(selectedOptions) => {
					const materials = selectedOptions.map(
						(option) => option.value,
					);
					setValue("materialTypes", materials);
				}}
				error={errors.materialTypes?.message}
			/>

			<div className="space-y-4">
				{shouldDisplayHT ? (
					<ControlledPriceInput
						control={control}
						name="totalFeesHT"
						label="Montant HT"
						iconOrText="€ HT"
						required
					/>
				) : (
					<ControlledPriceInput
						control={control}
						name="totalFeesTTC"
						label="Montant TTC"
						iconOrText="€ TTC"
						required
					/>
				)}
			</div>

			<div className="flex justify-end space-x-3">
				<Button
					type="button"
					variant="outline"
					onClick={onCancel}
					disabled={isSubmitting}
				>
					Annuler
				</Button>
				<Button
					type="button"
					onClick={onSubmit}
					disabled={isSubmitting}
					isLoading={isSubmitting}
				>
					Enregistrer
				</Button>
			</div>
		</div>
	);
};
